import type { ReactNode } from 'react'

export function Spinner({ label = 'Loading…' }: { label?: ReactNode }) {
  return <p className="px-1 py-6 text-center text-sm text-text-muted">{label}</p>
}

export function EmptyState({ title, hint }: { title: ReactNode; hint?: ReactNode }) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-1 p-10 text-center">
      <p className="text-sm font-medium text-text-default">{title}</p>
      {hint && <p className="text-sm text-text-muted">{hint}</p>}
    </div>
  )
}

export function ErrorState({ message }: { message?: ReactNode }) {
  return (
    <div className="flex flex-1 items-center justify-center p-10">
      <p className="text-sm text-text-muted">{message ?? 'Something went wrong. Please try again.'}</p>
    </div>
  )
}
